<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <ul
        style="
          font-size: 80%;
          font-weight: 600;
          margin-bottom: 3px;
          color: #696969;
        "
      >
        到款记录
      </ul>
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        ref="tableDom"
      >
        <el-table-column
          label="到款时间"
          prop="received_time"
          sortable="received_time"
          width="120"
          :formatter="$tab_TextFormat"
          fixed
        />
        <el-table-column
          label="付款人"
          prop="payment_name"
          :formatter="$tab_TextFormat"
          :min-width="160"
        />
        <el-table-column
          label="金额"
          prop="received_amount"
          align="right"
          :formatter="$tab_PriceFormat"
          min-width="140"
        />
        <el-table-column
          label="实际到账金额/手续费"
          align="right"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                $priceFormat(row.real_received_amount),
                $priceFormat(row.service_fee)
              )
          "
          min-width="160"
        />
        <el-table-column
          label="已认领/未认领金额"
          min-width="160"
          align="right"
        >
          <template #default="{ row }">
            <div style="display: flex; justify-content: flex-end">
              <c_tabgroup
                :value1="$priceFormat(row.collected_amount)"
                style="
                  align-items: flex-end;
                  display: flex;
                  flex-direction: column;
                "
              >
                <template #bottom>
                  <c_money
                    style="font-weight: 600"
                    :value="row.uncollected_amount"
                  />
                </template>
              </c_tabgroup>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="状态/ID" sortable="id" width="120">
          <template #default="{ row }">
            <div
              style="display: flex; flex-direction: column; width: fit-content"
            >
              <component
                :is="
                  $statusFormat2(
                    'bankReceived_collected_status',
                    row.collected_status
                  )
                "
              />
              <text
                style="
                  color: #a2a2a2;
                  font-size: var(--tab-group-second-font-size);
                  text-align: center;
                "
              >
                {{ row.id }}
              </text>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="匹配客户"
          prop="customer_name"
          width="200"
          :formatter="$tab_TextFormat"
        />
        <el-table-column
          label="到账银行"
          :formatter="
            (row) =>
              $tab_GroupFormat(
                row.bank_account?.account,
                row.bank_account?.opening_bank || ''
              )
          "
          min-width="220"
        />
        <el-table-column
          label="付款银行"
          :formatter="
            (row) =>
              $tab_GroupFormat(row.payment_account, row.payment_bank || '')
          "
          min-width="220"
        />
        <el-table-column label="摘要信息/认领明细" min-width="400">
          <template #default="{ row }">
            <div>
              <ul>
                {{
                  row.customer_name || "-"
                }}
              </ul>
              <ul
                v-if="row.collected_amount_detail?.collected"
                style="
                  color: #a2a2a2;
                  font-size: var(--tab-group-second-font-size);
                "
                v-html="
                  Object.keys(row.collected_amount_detail?.collected)
                    .map(
                      (key) =>
                        `${key}: <text style='color:#ffa500;margin-right:5px'>${$priceFormat(
                          row.collected_amount_detail?.collected[key]
                        )}</text>`
                    )
                    .join(' ')
                "
              ></ul>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <ul
        style="
          font-size: 80%;
          font-weight: 600;
          margin-bottom: 3px;
          margin-top: 10px;
          color: #696969;
        "
      >
        合并记录
      </ul>
      <el-descriptions border class="desc-label-nowrap" size="large">
        <el-descriptions-item label="状态" label-align="right">
          <div style="width: 200px">
            <c_status
              v-if="state.model?.id"
              arr-name="bankreceivedmerge_status"
              :value="state.model?.status"
            />
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="金额" label-align="right">
          <div style="width: 200px">
            {{ $priceFormat(state.model?.received_amount) }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="实际到账金额" label-align="right">
          <div style="width: 200px">
            {{ $priceFormat(state.model?.real_received_amount) }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="手续费" label-align="right">
          <div style="width: 200px">
            {{ $priceFormat(state.model?.service_fee) }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="主体到款记录Id" label-align="right">
          <div style="width: 200px">{{ state.model?.bank_received_id }}</div>
        </el-descriptions-item>
        <el-descriptions-item label="合并说明" label-align="right">
          <div style="width: 200px">
            {{ state.model?.remark || "-" }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="申请人" label-align="right">
          <div style="width: 200px">
            {{
              state.model?.add_admin_name +
              "/" +
              state.model?.add_department_name
            }}
          </div>
        </el-descriptions-item>
        <el-descriptions-item label="申请时间" label-align="right">
          <div style="width: 200px">{{ state.model?.create_time }}</div>
        </el-descriptions-item>
        <template v-if="state.model.is_back">
          <el-descriptions-item label="撤回说明" label-align="right">
            <div style="width: 200px">
              {{ state.model?.back_remark || "-" }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="撤回时间" label-align="right">
            <div style="width: 200px">{{ state.model?.update_time }}</div>
          </el-descriptions-item>
        </template>
        <template v-if="state.model.status != 0">
          <el-descriptions-item label="审核备注" label-align="right">
            <div style="width: 200px">{{ state.model?.msg || "-" }}</div>
          </el-descriptions-item>
          <el-descriptions-item label="审核人" label-align="right">
            <div style="width: 200px">
              {{
                state.model?.check_admin_name +
                "/" +
                state.model?.check_department_name
              }}
            </div>
          </el-descriptions-item>
          <el-descriptions-item label="审核时间" label-align="right">
            <div style="width: 200px">{{ state.model?.check_time }}</div>
          </el-descriptions-item>
        </template>
      </el-descriptions>
      <template v-if="state.model.status == 0 && !state.model.is_back">
        <ul
          style="
            font-size: 80%;
            font-weight: 600;
            margin-bottom: 3px;
            margin-top: 10px;
            color: #696969;
          "
        >
          操作审核
        </ul>
        <el-form
          :model="state.checkModel"
          label-width="auto"
          style="margin-top: 10px"
          ref="formDom"
        >
          <el-form-item
            label="审核状态"
            prop="status"
            :rules="[
              {
                required: true,
                message: '请选择自查处理结果',
                trigger: 'blur',
              },
            ]"
          >
            <el-radio-group v-model="state.checkModel.status">
              <el-radio :value="1" style="color: #1e90ff">通过</el-radio>
              <el-radio :value="2" style="color: #f00">不通过</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="审核意见" style="width: 50%">
            <el-input type="textarea" v-model="state.checkModel.msg" />
          </el-form-item>
        </el-form>
      </template>
    </ul>
    <ul
      class="submit-box"
      v-if="state.model.status == 0 && !state.model.is_back"
    >
      <el-button type="primary" @click="onSubmit">提交</el-button>
      <el-button type="info" @click="onClose">取消</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  bankreceivedmerge_detail,
  bankreceivedmerge_check,
} from "@/http/bankreceivedmerge";
import { bankcollected_list } from "@/http/bankcollected";
import { ElMessage, ElMessageBox } from "element-plus";
export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {},
      checkModel: {},
    });
    onMounted(() => {
      if (props.id) {
        bankreceivedmerge_detail(props.id).then((res) => {
          if (res.status == 200) {
            const { data } = res.data;
            state.model = data;
            bankcollected_list({
              limit: 0,
              id: data.bank_received_ids,
              is_more: true,
            }).then((res) => {
              if (res.status == 200) {
                const { list } = res.data.data;
                state.tableData = list;
              }
            });
          }
        });
      }
    });

    const onClose = () => {
      emit("close");
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          ElMessageBox.confirm(
            `您确定<strong style='color:${
              state.checkModel.status == 1 ? "#080" : "#f00"
            }'>${
              state.checkModel.status == 1 ? "同意" : "拒绝"
            }</strong>该到款合并申请吗？`,
            "提示",
            {
              dangerouslyUseHTMLString: true,
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            }
          ).then(() => {
            const { status, msg } = state.checkModel;
            bankreceivedmerge_check({
              id: props.id,
              status,
              msg,
            }).then((res) => {
              if (res.status == 200) {
                ElMessage({
                  message: res.data.msg,
                  dangerouslyUseHTMLString: true,
                  type: "success",
                });
                setTimeout(() => {
                  emit("confirm", true);
                }, 500);
              }
            });
          });
        }
      });
    };

    return { state, onClose, formDom, onSubmit };
  },
};
</script>
<style scoped lang="less"></style>
